import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PassThruWrapperComponent, LandingComponent } from 'ng-shared-library';
import { environment } from '../environments/environment';
import { LandingPortalGuard } from './guards/landing-portal.guard';

let routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [LandingPortalGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
